import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import images from "../common/images";
import { useQuery } from "@tanstack/react-query";
import ApiCall from "../services/apiCall";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Hero from "../components/Hero";

const Otp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState("");
  const [isLoading, setLoading] = useState(false);
  // Accessing state passed from the previous screen
  const { value, isPhoneNumber, isForget, password } = location.state || {};

  const onRegister = async () => {
    if (otp.length < 6) {
      toast.error(`Otp must be at least 6 characters}`);
    } else {
      const data = {
        email: value,
        otp: otp,
        password: password,
      };
      setLoading(true);
      try {
        const res = await ApiCall("api/register", "POST", JSON.stringify(data));
        if (res.ok == true) {
          localStorage.setItem("userData", JSON.stringify(res?.data));
          localStorage.setItem("userToken", JSON.stringify(res?.meta?.token));
          navigate("/", { replace: true });
        } else {
          toast.error(
            Array.isArray(res?.errors) && res?.errors[0]?.msg
              ? res.errors[0].msg
              : res?.message || "Something went wrong"
          );
        }
      } catch (error) {
        toast.error(error?.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const onSubmitOtp = async () => {
    if (password) {
      onRegister();
      return;
    }

    if (otp.length < 6) {
      toast.error(`Otp must be at least 6 characters}`);
    } else {
      if (isForget) {
        navigate("/reset-password", {
          state: {
            value: value,
            otp: otp,
          },
        });
      } else {
        let data = {
          username_type: "phoneNumber",
          username: value,
          otp: otp,
        };
        setLoading(true);
        try {
          const res = await ApiCall(
            "api/login/verify-otp",
            "POST",
            JSON.stringify(data)
          );
          if (res.ok == true) {
            localStorage.setItem("userData", JSON.stringify(res?.data));
            localStorage.setItem("userToken", JSON.stringify(res?.meta?.token));

            navigate("/", { replace: true });
          } else {
            toast.error(
              Array.isArray(res?.errors) &&
                res?.errors?.length &&
                res?.errors[0]?.msg
                ? res?.errors[0]?.msg
                : "Something went wrong"
            );
          }
        } catch (error) {
          console.log(error, "success");
          toast.error(error?.message);
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const resendOtp = async () => {
    setOtp("");
    let data = {};
    if (isPhoneNumber) {
      data.phoneNumber = value;
    } else {
      data.email = value;
    }
    try {
      const res = await ApiCall("api/send-otp", "POST", JSON.stringify(data));
      toast.success(
        typeof res?.message == "string"
          ? res?.message
          : "Something went wrong" || "Something went wrong"
      );
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const resendForgetMailOtp = async () => {
    let data = JSON.stringify({
      email: value,
    });
    try {
      const res = await ApiCall("api/forgot-password", "POST", data);
      toast.success(res?.message || "Something went wrong");
    } catch (error) {
      toast.error(error?.message);
    }
  };

  return (
    <Layout>
      <Hero title="OTP" />
      {/* Login Section */}
      <section
        className="login-section section-gap wow fadeInUp"
        data-wow-delay="0.3s"
      >
        <div className="midd-section">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-sec">
                <h2 className="title-30 wow fadeInUp" data-wow-delay="0.2s">
                  Enter OTP
                </h2>
                <p className="p-20 font-600 wow fadeInUp" data-wow-delay="0.3s">
                  {`Check your ${
                    isPhoneNumber ? "phone" : "email"
                  }, we’ve sent you the OTP at ${value}`}
                </p>
              </div>
              <div className="form-sec">
                <form className="wow fadeInUp" data-wow-delay="0.2s">
                  <div className="input-sec">
                    <input
                      type="phone"
                      name=""
                      placeholder="Enter the OTP"
                      className="form-control"
                      onChange={(e) => {
                        setOtp(e.target.value);
                      }}
                    />
                  </div>
                  <div className="btn-sec">
                    <button type="button" className="btn" onClick={onSubmitOtp}>
                      Submit OTP
                    </button>
                  </div>
                </form>
                <div className="sign-option">
                  <span
                    className="sign-up-option wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <p>
                      Don't receive OTP?{" "}
                      <a
                        onClick={() => {
                          if (isForget) {
                            resendForgetMailOtp();
                          } else {
                            resendOtp();
                          }
                        }}
                      >
                        Resend
                      </a>
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Login Section End */}
      <a href="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </a>
      <ToastContainer />
    </Layout>
  );
};

export default Otp;
